import { OverlayType } from '../../constants/common'
import BaseConfig from './overlayBaseConfig'

export type Options = {
  period: number
  deviations: number
}

export interface Attrs extends Options {
  topColor?: string
  bottomColor?: string
}

export class BBConfig extends BaseConfig {
  static type = OverlayType.Bb
  static abbreviation = 'bb'
  static label = 'Bollinger Bands'
  static shortLabel = 'BB'
  static description =
    'Bollinger Bands are a volatility indicator that consists of three lines: a middle line (20 period simple moving average), an upper band (2 standard deviations above the SMA), and a lower band (2 standard deviations below the SMA). They help identify overbought or oversold conditions; prices near the upper band may indicate overbought, while prices near the lower band may suggest oversold conditions.'

  static optionsOrder = ['period', 'deviations'] as const
  static optionsLabels = { period: 'Period', deviations: 'Deviations' }
  static inputsOrder = ['period', 'deviations', 'topColor', 'bottomColor'] as Array<keyof Attrs>
  static inputsLabels = {
    period: 'Period',
    deviations: 'Deviations',
    topColor: 'Top Color',
    bottomColor: 'Bottom Color',
  }

  static calculatedValuesOrder = ['upperBand', 'sma', 'lowerBand'] as const
  static calculatedValuesLabels = {
    sma: 'SMA',
    upperBand: 'Upper Band',
    lowerBand: 'Lower Band',
  }

  static defaultCalculatedValueOption = this.calculatedValuesOrder[1]
}
